/**
 * InventoryWorkspace — Editor territorial e inventario urbano
 *
 * @remarks
 * Renderiza MapLayout completo con modos limitados a explore e inventory.
 * Es el workspace operativo principal: edicion de red, inventario de entidades,
 * modulos tematicos, herramientas de mapa.
 *
 * La vista lista+detalle sin mapa (Fase 3a) se recuperara como vista
 * alternativa en Fase 3b (toggle lista/mapa).
 */

import { useEffect } from 'react';
import { MapLayout } from '../layouts/MapLayout';
import { useOperationalModeStore } from '../operational-modes';
import type { OperationalMode } from '../operational-modes';

const INVENTORY_VISIBLE_MODES: OperationalMode[] = ['explore', 'inventory'];

export function InventoryWorkspace(): JSX.Element {
  const mode = useOperationalModeStore(s => s.mode);
  const setMode = useOperationalModeStore(s => s.setMode);

  useEffect(() => {
    if (!INVENTORY_VISIBLE_MODES.includes(mode)) {
      setMode('inventory');
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return <MapLayout visibleModes={INVENTORY_VISIBLE_MODES} />;
}
